<template>
  <b-row>
    <b-col cols="12">
      <b-modal
        :visible="true"
        size="lg"
        title="Subir tareas mediante Excel"
        :ok-title="btnDisabled ? 'Subiendo...' : 'Subir tareas'"
        cancel-title="Cancelar"
        :okDisabled="btnDisabled"
        id="new-outgoing-payment"
        @ok="uploadCSV"
        @hidden="modalHidden"
      >
        <b-row>
          <b-col :cols="12">
            <div class="mt-2">
              <b-row>
                <b-col cols="12">
                  <b-alert v-if="errorCode" :show="error" variant="danger">{{
                    `${errorCode}`
                  }}</b-alert>
                  <b-alert
                    v-else-if="!errorCode"
                    :show="error"
                    variant="danger"
                    >{{ 'Ha habido un error. Contacta con sopporte.' }}</b-alert
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-form-group
                  label="Fichero"
                  description="Debe seguir el mismo formato que el archivo Excel descargable en la página 'Listado de tareas' mediante el botón 'Descargar Excel'"
                  class="col-12"
                >
                  <b-form-file
                    @change="error = false"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    v-model="modalData.file"
                    :state="Boolean(modalData.file)"
                  ></b-form-file>
                </b-form-group>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

export default {
  name: 'UpdateWorkshopTasksViaExcelModal',
  props: ['family'],

  components: {},
  data() {
    return {
      btnDisabled: false,
      error: false,
      errorCode: '',
      modalData: {
        file: null,
      },
    };
  },
  created() {},
  methods: {
    modalHidden() {
      this.$emit('hidden');
    },
    uploadCSV(bvModalEvt) {
      this.error = false;

      this.btnDisabled = true;

      bvModalEvt.preventDefault();

      let data = new FormData();
      data.append('file', this.modalData.file);

      actions
        .postWorkshopTasksUploadExcel(this.family, data)
        .then(() => {
          this.btnDisabled = false;
          this.error = false;
          this.$emit('updateDone');

          this.$nextTick(() => {
            this.$bvModal.hide('modal-prevent-closing');
          });
        })
        .catch((err) => {
          console.log(err.response.data.detail);
          this.error = true;
          if (err.response && err.response.data && err.response.data.file) {
            this.errorCode = err.response.data.file;
          } else if (
            err.response &&
            err.response.data &&
            err.response.data.detail
          ) {
            this.errorCode = err.response.data.detail;
          }

          this.btnDisabled = false;
        });
    },
  },
  computed: {},
  mounted() {},
  updated() {
    //this.renderViews();
  },
};
</script>

<style scoped>
.canvas {
  width: 100%;
  height: 40em;
  /*background: #ebebeb;*/
}
</style>
